import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { UserService } from "../../../../shared";
import { SchoolService } from "../../../../shared/services/school.service";
import { AcademyService } from "../../../Report/report-services/academy.service";
import { GradeLevelService } from "../../../Report/report-services/grade-level.service";
import { GroupService } from "../../../Report/report-services/group.service";
import { HomeroomService } from "../../../Report/report-services/homeroom.service";
import { BTBusMapSelectorBusRequest } from "../shared/BTBusMapSelectorBusRequest";
import { BTBusMapSelectorStudentRequest } from "../shared/BTBusMapSelectorStudentRequest";
import { DataService_BusTrackerMap } from "../shared/data.service";

@Component({
	selector: "caass-bus-selector",
	templateUrl: "./bus-selector.component.html",
	styleUrls: ["./bus-selector.component.css"],
})
export class BusSelectorComponent implements OnInit {
	constructor(
		private userService: UserService,
		private schoolService: SchoolService,
		private homeroomService: HomeroomService,
		private academyService: AcademyService,
		private gradelevelService: GradeLevelService,
		private groupService: GroupService,
		private mapService: DataService_BusTrackerMap
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadSchool();
	}

	/////////////////////////////////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////////////////////////////////

	@Output() SelectedChanged: EventEmitter<any> = new EventEmitter();

	user: any;

	SearchMode: any = "Bus";
	lstSearchMode: any = ["Bus", "Student"];

	SchoolLoading: any = false;
	School: any;
	lstSchool: any = [];

	GradeLevelLoading: any = false;
	GradeLevel: any;
	lstGradeLevel: any = [];

	AcademyLoading: any = false;
	Academy: any;
	lstAcademy: any = [];

	HomeroomLoading: any = false;
	Homeroom: any;
	lstHomeroom: any = [];

	GroupLoading: any = false;
	Group: any;
	lstGroup: any = [];

	HasAlertID: any = -1;
	lstHasAlert: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Has Active Alert",
		},
		{
			ID: 0,
			Desc: "No Active Alert",
		},
	];

	ActiveID: any = -1;
	lstActive: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Active",
		},
		{
			ID: 0,
			Desc: "Inactive",
		},
	];

	Filter: any = "";

	lstBusSearchData: any = [];
	lstStudentSearchData: any = [];

	SelectedBuses: any = [];

	TableLoading: any = false;

	ApplicationItemID: any = "4D921BE8-C937-44C8-88AE-F21B8AD97DCD";

	/////////////////////////////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////////////////////////////////////
	loadSchool() {
		var result = this.schoolService.loadSchoolList(this.ApplicationItemID);
		result.subscribe(
			(response) => {
				this.lstSchool = response;

				this.lstSchool.unshift({
					SchoolID: -1,
					SchoolName: "All",
					SchoolFullName: "All",
				});

				this.School = this.lstSchool[0];

				this.loadGradeLevel();
			},
			(error) => {}
		);
	}

	loadGradeLevel() {
		var result = this.gradelevelService.loadGradeLevelList(0, this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstGradeLevel = response;

				if (this.lstGradeLevel.length == 0) {
					this.lstGradeLevel.unshift({
						GradeLevelID: -1,
						GradeLevelDesc: "All Grade Levels",
					});
				}

				this.GradeLevel = this.lstGradeLevel[0];

				this.loadAcademy();
			},
			(error) => {}
		);
	}

	loadAcademy() {
		var result = this.academyService.loadAcademyList(0, this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstAcademy = response;

				if (this.lstAcademy.length == 0) {
					this.lstAcademy.unshift({
						AcademyId: -1,
						AcademyDesc: "All Academies",
					});
				}

				this.Academy = this.lstAcademy[0];

				this.loadHomeroom();
			},
			(error) => {}
		);
	}

	loadHomeroom() {
		var result = this.homeroomService.loadHomeroomList(0, this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstHomeroom = response;

				if (this.lstHomeroom.length == 0) {
					this.lstHomeroom.unshift({
						HomeroomId: -1,
						HomeRoom: "All Homerooms",
					});
				}

				this.Homeroom = this.lstHomeroom[0];

				this.loadGroup();
			},
			(error) => {}
		);
	}

	loadGroup() {
		var result = this.groupService.loadGroupList(0, this.School.SchoolID);
		result.subscribe(
			(response) => {
				this.lstGroup = response;

				if (this.lstGroup.length == 0) {
					this.lstGroup.unshift({
						GroupID: -1,
						GroupName: "All Groups",
					});
				}

				this.Group = this.lstGroup[0];
			},
			(error) => {}
		);
	}

	/////////////////////////////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////////////////////////////////////
	onSearch() {
		if (this.SearchMode == "Bus") {
			this.onBusSearch();
		} else if (this.SearchMode == "Student") {
			this.onStudentSearch();
		}
	}

	onBusSearch() {
		this.TableLoading = true;

		//
		// Create Request
		//

		let parms: BTBusMapSelectorBusRequest = {
			HasAlert: this.HasAlertID,
			Active: this.ActiveID,
			Filter: this.Filter,
			UserID: this.user.userID,
		};

		//
		// Call SP
		//

		var result = this.mapService.BusMapSelectorBusModeSelectList(parms);
		result.subscribe(
			(response) => {
				this.lstBusSearchData = response;

				this.TableLoading = false;
			},
			(error) => {
				this.TableLoading = false;
			}
		);
	}

	onStudentSearch() {
		this.TableLoading = true;

		//
		// Create Request
		//

		let parms: BTBusMapSelectorStudentRequest = {
			SchoolID: this.School.SchoolID,
			GradeLevelID: this.GradeLevel.GradeLevelID,
			AcademyID: this.Academy.AcademyId,
			HomeroomID: this.Homeroom.HomeroomId,
			GroupID: this.Group.GroupID,
			Active: this.ActiveID,
			Filter: this.Filter,
			UserID: this.user.userID,
		};

		//
		// Call SP
		//

		var result = this.mapService.BusMapSelectorStudentModeSelectList(parms);
		result.subscribe(
			(response) => {
				this.lstStudentSearchData = response;

				this.TableLoading = false;
			},
			(error) => {
				this.TableLoading = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////////////////////////////////////////////
	onSearchModeChange(val) {
		this.SearchMode = val;
		this.Filter = "";

		//Clear Results
		this.SelectedBuses = [];
		this.lstBusSearchData = [];
		this.lstStudentSearchData = [];
		this.SelectBusesOnMap();

		//Load?
	}

	onSchoolChange(val) {
		this.School = val;

		//Load Data
		this.loadGradeLevel();
		this.loadAcademy();
		this.loadHomeroom();
		this.loadGroup();
	}

	onBusSelectChange(val) {
		this.SelectedBuses = val;

		this.SelectBusesOnMap();
	}

	onFilterKeyDown(event) {
		if (event.key == "Enter") {
			var SearchButton = document.getElementById("SearchButton");

			SearchButton.focus();
			SearchButton.click();
		}
	}

	/////////////////////////////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////////////////////////////////////

	SelectBusesOnMap() {
		let lstBusIDs: any = [];
		let lstStudentIDs: any = [];

		try {
			if (this.SearchMode == "Bus") {
				lstBusIDs = Array.from(new Set(this.SelectedBuses.map((item: any) => item.BusID)));
			} else if (this.SearchMode == "Student") {
				lstBusIDs = Array.from(new Set(this.SelectedBuses.map((item: any) => item.CurrentBusID)));
			}

			lstStudentIDs = Array.from(new Set(this.SelectedBuses.map((item: any) => item.PersonID)));
		} catch (e) {
			// console.log(e);
			e.toString();
		}

		if (this.SearchMode == "Bus") {
			this.SelectedChanged.emit({ Buses: lstBusIDs, Students: [] });
		} else if (this.SearchMode == "Student") {
			this.SelectedChanged.emit({
				Buses: lstBusIDs,
				Students: lstStudentIDs,
			});
		}
	}

	IsLoading() {
		return false;
	}

	/////////////////////////////////////////////////////////////////////////////////////////////////
}
